
module.exports = {

    methods: {
        verifyPermitNumber(permit_number, project_slug) {
            // Alert.confirmation().then((text) => {
            //     this.redirectTo(`/projects/${project_slug}/acceptance-documents/signature`);
            // }).catch(() => {
            //
            // })*/
            var text = `Permit Number:<br><b>${permit_number}</b>`;

            Alert.create().fire({
                html: text,
                input: 'checkbox',
                inputPlaceholder: 'I have verified that all NRCI forms are completed and signed.'
            }).then(function(result) {
                if (result.value) {
                    Swal.fire({icon: 'success', text: 'You have a bike!'});
                } else if (result.value === 0) {
                    Swal.fire({icon: 'error', text: "You don't have a bike :("});
                } else {
                    console.log(`modal was dismissed by ${result.dismiss}`)
                }
            })
        }
    }
}
